import { render, staticRenderFns } from "./CabinCategoryItem.vue?vue&type=template&id=22014690&"
import script from "./CabinCategoryItem.ts?vue&type=script&lang=ts&"
export * from "./CabinCategoryItem.ts?vue&type=script&lang=ts&"
import style0 from "./CabinCategoryItem.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports